import { render, staticRenderFns } from "./Rota.vue?vue&type=template&id=437c9002&class=auto-container-rota"
import script from "./Rota.vue?vue&type=script&lang=js"
export * from "./Rota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports